import React from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Checkbox,
  Typography,
  IconButton,
  Popover
} from "@mui/material";
import { Visibility, FilterList, Close } from "@mui/icons-material";
import LoadingSpinner from "../../Loading/component";
import successicon from "../../../assests/success.svg"
import './uidDashboard.css';
import ListOfCreatedUid from './ListOfcreatedUids/ListofCreatedUids';
import BulkQRCodeGenerator from './BulkQRCodeGenerator';
import moment from 'moment-timezone';

const UidDashboardComponent = ({
  uids,
  loading,
  error,
  searchTerm,
  currentPage,
  hasMore,
  
  showSuccessDialog,
  createdUids,
  showErrorDialog,
  errorMessage,
  createUidOpen,
  apiLoading,
  showListPage,
  
  showBulkQRDialog,
  qrUids,
  pdfDownloading,
  setShowBulkQRDialog,
  
  statusFilter,
  mappingStateFilter,
  statusFilterAnchorEl,
  mappingFilterAnchorEl,
  statusOptions,
  mappingStateOptions,
  
  selectedUids,
  selectAll,
  
  newUidData,
  
  navigate,
  
  setSearchTerm,
  onLoadNextPage,
  handleCreateUid,
  handleCloseCreateUid,
  handleCreateUidSubmit,
  handleBulkUpload,
  handleInputChange,
  handleUidSelect,
  handleSelectAll,
  isUidSelected,
  handleDownloadSelected,
  handleViewDetails,
  handleStatusFilterClick,
  handleMappingFilterClick,
  handleStatusFilterSelect,
  handleMappingStateFilterSelect,
  handleCloseStatusFilterPopup,
  handleCloseMappingFilterPopup,
  handleClearStatusFilter,
  handleClearMappingFilter,
  handleBackFromList,
  onCloseSuccessDialog,
  onCloseErrorDialog,
  onPDFDownloadComplete,
  formatDate,
  onDownloadAndRedirect,
  filteredUids // Add this prop to get filtered uids
}) => {

  const handleViewDetailsWithRouting = (uid) => {
    if (uid.mappingState === 'Mapped') {
      navigate(`/uid-unmap/${uid.uid || uid.uid}`);
    } else if (uid.mappingState === 'Unmapped') {
      navigate(`/uid-map/${uid.uid || uid.uid}`);
    } else {
      handleViewDetails(uid);
    }
  };

  // Handle key press to prevent decimal input
  const handleKeyPress = (e) => {
    // Prevent decimal point, minus, plus, and 'e' (scientific notation)
    if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  // Handle paste to remove non-digit characters
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    // Remove any non-digit characters from pasted text
    const cleanText = pastedText.replace(/[^\d]/g, '');
    // Remove leading zeros
    const finalText = cleanText.replace(/^0+/, '') || '';
    handleInputChange('uid', finalText);
  };

  // Success Dialog Component
  const SuccessDialog = () => (
    <Dialog open={showSuccessDialog} maxWidth="sm" fullWidth style={{ width: "500px", margin: "auto" }}>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: "center", flexDirection: "column" }}>
          <img src={successicon} alt="" style={{ width: 58, height: 58 }} />
          <Typography className='uid-success-main-title'>Successfully</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="uid-success-dialog-content">
          <p>{createdUids.length} New UID(s) Created Successfully</p>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>
            Your CSV and QR PDF are being generated automatically.
          </p>
        </div>
      </DialogContent>
      <DialogActions className='uid-action-btn'>
        <Button variant='outlined' onClick={onCloseSuccessDialog} className="uid-success-ok-btn">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Error Dialog Component
  const ErrorDialog = () => (
    <Dialog
      open={showErrorDialog}
      onClose={onCloseErrorDialog}
      maxWidth="sm"
      fullWidth
      className="uid-error-dialog"
    >
      <DialogTitle className="uid-error-dialog-title">
        <div className="error-dialog-header">
          <div className="error-icon">⚠️</div>
          <div className="error-title-content">
            <div className="error-main-title">Error</div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="error-message">
          {errorMessage || 'An error occurred while processing your request.'}
        </div>
      </DialogContent>
      <DialogActions className="uid-error-dialog-actions">
        <Button
          onClick={onCloseErrorDialog}
          className="error-ok-btn"
          variant="contained"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Status Filter Popover Component
  const StatusFilterPopover = () => (
    <Popover
      id="status-filter-popover"
      open={Boolean(statusFilterAnchorEl)}
      anchorEl={statusFilterAnchorEl}
      onClose={handleCloseStatusFilterPopup}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      className="filter-popover"
    >
      <div className="filter-popover-content">
        <div className="filter-popover-header">
          <Typography className="filter-title">Filter by Status</Typography>
          <IconButton 
            className="filter-close-btn"
            onClick={handleCloseStatusFilterPopup}
            size="small"
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
        <div className="filter-list">
          {statusOptions.map((option) => (
            <div
              key={option}
              className={`filter-list-item ${statusFilter === option ? 'active' : ''}`}
              onClick={() => handleStatusFilterSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
        <div className="filter-popover-actions">
          <Button 
            onClick={(e) => {
              e.stopPropagation(); // Prevent event bubbling
              handleClearStatusFilter();
              handleCloseStatusFilterPopup();
            }}
            className="clear-filters-btn"
            disabled={!statusFilter}
          >
            Clear Filter
          </Button>
        </div>
      </div>
    </Popover>
  );

  // Mapping State Filter Popover Component
  const MappingFilterPopover = () => (
    <Popover
      id="mapping-filter-popover"
      open={Boolean(mappingFilterAnchorEl)}
      anchorEl={mappingFilterAnchorEl}
      onClose={handleCloseMappingFilterPopup}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      className="filter-popover"
    >
      <div className="filter-popover-content">
        <div className="filter-popover-header">
          <Typography className="filter-title">Filter by Mapping State</Typography>
          <IconButton 
            className="filter-close-btn"
            onClick={handleCloseMappingFilterPopup}
            size="small"
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
        <div className="filter-list">
          {mappingStateOptions.map((option) => (
            <div
              key={option}
              className={`filter-list-item ${mappingStateFilter === option ? 'active' : ''}`}
              onClick={() => handleMappingStateFilterSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
        <div className="filter-popover-actions">
          <Button 
            onClick={(e) => {
              e.stopPropagation(); // Prevent event bubbling
              handleClearMappingFilter();
              handleCloseMappingFilterPopup();
            }}
            className="clear-filters-btn"
            disabled={!mappingStateFilter}
          >
            Clear Filter
          </Button>
        </div>
      </div>
    </Popover>
  );

  // If showListPage is true, render the ListOfCreatedUid component
  if (showListPage) {
    return (
      <ListOfCreatedUid
        createdUids={createdUids}
        onBack={handleBackFromList}
        onStartPDFDownload={onDownloadAndRedirect}
        pdfDownloading={pdfDownloading}
        onPDFDownloadComplete={onPDFDownloadComplete}
      />
    );
  }

  // Get all UIDs from filtered data
  const filteredUidIds = filteredUids.map(uid => uid.uid);
  
  // Check if all filtered UIDs are selected
  const allFilteredSelected = filteredUidIds.length > 0 && filteredUidIds.every(id => selectedUids.has(id));

  // Handle select all for filtered items only
  const handleSelectAllFiltered = () => {
    if (allFilteredSelected) {
      // Deselect all filtered UIDs
      const newSelected = new Set(selectedUids);
      filteredUidIds.forEach(id => newSelected.delete(id));
      handleSelectAll(newSelected);
    } else {
      // Select all filtered UIDs
      const newSelected = new Set(selectedUids);
      filteredUidIds.forEach(id => newSelected.add(id));
      handleSelectAll(newSelected, true);
    }
  };

  // Main Dashboard UI
  return (
    <div className="uid-dashboard-container">
      {/* Full page loader overlay */}
      {loading && currentPage === 0 && (
        <div className="uid-full-page-loader">
          <LoadingSpinner />
        </div>
      )}

      <Sidebar />
      <div className="uid-dashboard-content">
        {/* Header Section */}
        <div className="uid-header-section">
          <Button
            className="uid-back-button"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="Back" />
          </Button>
          <h1 className="uid-main-title">UID's Dashboard</h1>
        </div>

        {/* Search and Actions Section */}
        <div className="uid-search-actions-section">
          <div className="uid-search-container">
            <div className="uid-search-input-container">
              <input
                type="text"
                placeholder=" Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="uid-search-input"
              />
            </div>
          </div>

          <div className="uid-actions-container-main">
            <Button
              variant="outlined"
              className="uid-create-btn"
              onClick={handleCreateUid}
              disabled={apiLoading}
            >
              {apiLoading ? <CircularProgress size={20} /> : 'Create UID'}
            </Button>
            <Button
              variant="outlined"
              className="uid-bulk-btn"
              onClick={handleBulkUpload}
            >
              Bulk Upload
            </Button>
            <Button
              className="uid-download-btn"
              onClick={handleDownloadSelected}
              disabled={selectedUids.size === 0}
              startIcon={
                <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
              }
            >
              ({selectedUids.size})
            </Button>
          </div>
        </div>

        {/* UID Table Section */}
        <div className="uid-table-section">
          <div className="uid-table-container">
            <table className="uid-main-table">
              <thead>
                <tr>
                  <th className="uid-table-checkbox">
                    <Checkbox
                      checked={allFilteredSelected}
                      onChange={handleSelectAllFiltered}
                      indeterminate={selectedUids.size > 0 && !allFilteredSelected}
                      disabled={filteredUidIds.length === 0}
                    />
                  </th>
                  <th className="uid-table-header">S.No.</th>
                  <th className="uid-table-header">UID</th>
                  <th className="uid-table-header">VMID</th>
                  <th className="uid-table-header">VM Name</th>
                  <th className="uid-info-header">Last Update</th>
                  <th className="uid-info-header">
                    <div className="filter-header-cell">
                      Status
                      <IconButton
                        className={`uid-filter-button header-filter-btn ${statusFilter ? 'active' : ''}`}
                        onClick={handleStatusFilterClick}
                        aria-label="Filter Status"
                        size="small"
                      >
                        <FilterList fontSize="small" />
                      </IconButton>
                    </div>
                  </th>
                  <th className="uid-info-header">
                    <div className="filter-header-cell">
                      Mapping State
                      <IconButton
                        className={`uid-filter-button header-filter-btn ${mappingStateFilter ? 'active' : ''}`}
                        onClick={handleMappingFilterClick}
                        aria-label="Filter Mapping State"
                        size="small"
                      >
                        <FilterList fontSize="small" />
                      </IconButton>
                    </div>
                  </th>
                  <th className="uid-info-header">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUids.length > 0 ? (
                  filteredUids.map((uid, index) => (
                    <tr key={uid.id || `${uid.uid}-${index}`} className="uid-table-row">
                      <td className="uid-table-checkbox">
                        <Checkbox
                          checked={isUidSelected(uid.uid)}
                          onChange={() => handleUidSelect(uid.uid)}
                        />
                      </td>
                      <td className="uid-table-sno">{index + 1}</td>
                      <td className="uid-table-uid">{uid.uid || 'N/A'}</td>
                      <td className="uid-table-vmid">{uid.vmId || 'N/A'}</td>
                      <td className="uid-table-vmname">{uid.vmName || 'N/A'}</td>
                      <td className="uid-date-cell">
                        {formatDate(uid.lastUpdatedAt)}
                      </td>
                      <td className="uid-status-cell">
                        <span className={`uid-status-badge uid-status-${uid.status?.toString()?.toLowerCase() || 'unknown'}`}>
                          {uid.status || 'N/A'}
                        </span>
                      </td>
                      <td className="uid-mapping-cell">
                        <span className={`uid-mapping-badge uid-mapping-${uid.mappingState?.toLowerCase() || 'unknown'}`}>
                          {uid.mappingState || 'N/A'}
                        </span>
                      </td>
                      <td className="uid-actions-cell">
                        <div className="uid-actions-container">
                          <IconButton
                            className="uid-view-btn"
                            onClick={() => handleViewDetailsWithRouting(uid)}
                            size="small"
                            title={`View Details`}
                          >
                            <Visibility />
                          </IconButton>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  !loading && (
                    <tr>
                      <td colSpan="9" className="uid-no-data">
                        No UIDs found
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>

            {/* Load More Button */}
            {hasMore && filteredUids.length > 0 && (
              <div className="uid-load-more-container">
                <Button
                  variant="outlined"
                  onClick={onLoadNextPage}
                  disabled={loading}
                  className="uid-load-more-btn"
                >
                  {loading ? <CircularProgress size={20} /> : 'Load More'}
                </Button>
              </div>
            )}
          </div>
        </div>

        {/* Create UID Dialog */}
        <Dialog
          open={createUidOpen}
          maxWidth="sm"
          fullWidth
          className="uid-create-dialog"
        >
          <DialogTitle className="uid-dialog-title">
            Create UID
          </DialogTitle>
          <DialogContent className="uid-dialog-content">
            <div className="uid-form-container">
              <TextField
                label="Enter The Count Of UIDs To Create *"
                value={newUidData.uid}
                onChange={(e) => handleInputChange('uid', e.target.value)}
                onKeyPress={handleKeyPress}
                onPaste={handlePaste}
                fullWidth
                margin="normal"
                className="uid-form-field"
                placeholder="Max 50 Numbers can be created at once"
                type="text"
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  maxLength: 2
                }}
                helperText="Enter a number between 1 and 50"
              />
            </div>
          </DialogContent>
          <DialogActions className="uid-dialog-actions">
            <Button onClick={handleCloseCreateUid} className="uid-cancel-btn" disabled={apiLoading}>
              Cancel
            </Button>
            <Button onClick={handleCreateUidSubmit} className="uid-create-submit-btn" disabled={apiLoading}>
              {apiLoading ? <CircularProgress size={20} /> : 'Create UID'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Success Dialog */}
        <SuccessDialog />

        {/* Error Dialog */}
        <ErrorDialog />

        {/* Filter Popovers */}
        <StatusFilterPopover />
        <MappingFilterPopover />
    
        {/* Bulk QR Code Generator */}
        <BulkQRCodeGenerator
          open={showBulkQRDialog}
          onClose={() => setShowBulkQRDialog(false)}
          uids={qrUids}
          pdfDownloading={pdfDownloading}
          onPDFDownloadComplete={onPDFDownloadComplete}
        />
      </div>
    </div>
  );
};

export default UidDashboardComponent;